module.exports = __webpack_public_path__ + "assets/img/hospital.48659968.png";